<template>
  <div class="AlertBarSiteJwt">
    <transition appear name="slide-up">
      <Notice
        v-if="isSomeSitesJwtExpired && !isClosed"
        class="danger"
        :isClosable="true"
        @close="isClosed = true">
        {{ $t('jwtExpired') }}
        <Route class="Btn ib" to="Sites">
          {{ $t('checkSites') }}
        </Route>
      </Notice>
    </transition>
  </div>
</template>

<script>
import { getters } from '@utils'

export default {
  data() {
    return {
      isClosed: false,
    }
  },
  computed: {
    isSomeSitesJwtExpired() {
      const now = Date.now()
      return this.query('site')
        .some(({ jwtExpiresAt }) => new Date(jwtExpiresAt) < now)
    },
    ...getters(),
  },
}
</script>

<style lang="scss">
.AlertBarSiteJwt {
  bottom: 0;
  left: 0;
  position: fixed;
  right: 0;
  width: 100%;
  z-index: 31;

  .Notice {
    margin: 0;

    .Btn {
      line-height: 1.25rem;
      margin-left: 1rem;
      padding: 0 1rem;
    }
  }
}
</style>
<i18n>
{
  "en": {
    "checkSites":"Check sites",
    "jwtExpired": "Some sites jwt expired"
  }
}
</i18n>
